<template>
  <div id="tabs-page" class="d-flex">
    <div class="sidebar">
      <ul class="nav flex-column">
        <li v-for="(tab, index) in tabs" :key="index" class="nav-item">
          <RouterLink class="nav-link disabled" :to="tab.path">
            {{ tab.name }}
          </RouterLink>
        </li>
      </ul>
    </div>

    <!-- Content Area -->
    <div class="content">
      <RouterView></RouterView>
    </div>
  </div>
</template>

<script>
import { RouterLink, RouterView } from "vue-router";
import { mapState } from "vuex";
export default {
  data() {
    return {
      tabs: [
        { name: "Sim Info", path: "/customers/customer_activation/sim-info" },
        { name: "Plan Info", path: "/customers/customer_activation/plan-info" },
        {
          name: "Customer Info",
          path: "/customers/customer_activation/customer-info",
        },
        {
          name: "Contract Review",
          path: "/customers/customer_activation/contract-review",
        },
        { name: "Payment", path: "/customers/customer_activation/payment" },
        { name: "Confirm", path: "/customers/customer_activation/confirm" },
      ],
    };
  },
  components: {
    RouterLink,
    RouterView,
  },
  computed: {
    ...mapState({
      activationStage: (state) => state.customerActivationNew.activationStage,
    }),
  },
  methods: {
    nextTab() {
      let tabIndex = 0;

      this.tabs.forEach((el, ind) => {
        if (el.path == this.$route.path) {
          tabIndex = ind;
        }
      });
      if (tabIndex < 5) this.$router.push(this.tabs[tabIndex + 1].path);
      else {
        this.$router.push("/customers");
      }
    },
  },
  watch: {
    activationStage(val) {
      const links = document.querySelectorAll(".nav-item a");
      links.forEach((link, i) => {
        if (i > val) {
          link.classList.add("disable-link");
        } else {
          link.classList.remove("disable-link");
        }
      });
    },
  },
  beforeMount() {
    this.$router.push("/customers/customer_activation/sim-info");
    this.$store.dispatch("customerActivationNew/clearActivationData");
  },
  mounted() {
    const links = document.querySelectorAll(".nav-item a");

    links.forEach((link, i) => {
      if (i > 0) link.classList.add("disable-link");
    });
  },
};
</script>

<style>
#tabs-page {
  display: flex;
}

.sidebar {
  width: 220px;
  height: fit-content;
  border: 1px solid #dee2e6;
  padding: 10px;
  margin-top: 2rem;
  background-color: #f8f9fa;
}

.nav {
  list-style: none;
  padding: 0;
}

.nav-item {
  margin-bottom: 10px;
}

.nav-link {
  display: block;
  padding: 10px 15px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.nav-link.router-link-active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}

.content {
  flex: 1;
  padding: 10px;
}
.disable-link {
  cursor: not-allowed;
  pointer-events: none;
}
</style>
